const HeroSliderImgs = [
  {
    desktop: "./imgs/hero-imgs/img1.webp",
    phone: "./imgs/hero-imgs/img1-phone.webp",
  },
  {
    desktop: "./imgs/hero-imgs/img2.webp",
    phone: "./imgs/hero-imgs/img2-phone.webp",
  },
  {
    desktop: "./imgs/hero-imgs/img3.webp",
    phone: "./imgs/hero-imgs/img3-phone.webp",
  },
];

export default HeroSliderImgs;
